<script lang="ts">
    import { cn } from "../../utils.js";
    import type { HTMLAttributes } from "svelte/elements";
    import * as Tooltip from "../ui/tooltip/index.js";

    const { value, class: className }: { value: string | null } & HTMLAttributes<HTMLDivElement> = $props();
    let node = $state<HTMLDivElement>();
    let disabled = $state(true);
    $effect(() => {
        void value;
        void className;
        disabled = !node || node.scrollWidth <= node.clientWidth;
    });
</script>

<Tooltip.Root {disabled}>
    <Tooltip.Trigger>
        {#snippet child({ props })}
            <div bind:this={node} {...props} class={cn("overflow-hidden text-ellipsis whitespace-nowrap", className)}>
                {value}
            </div>
        {/snippet}
    </Tooltip.Trigger>
    <Tooltip.Content>{value}</Tooltip.Content>
</Tooltip.Root>
